// Webpack resolves @rails/ujs to the ESM build, which exports { default: Rails }.
// require("@rails/ujs").start() breaks; use .default when present (see rails-ujs package "module" field).
const ujs = require("@rails/ujs")
const Rails = ujs.default ?? ujs
Rails.start()
